export const ENVIRONMENT_NAME = {
  DEVELOPMENT: 'DEVELOPMENT',
  LOCAL: 'LOCAL',
  STAGING: 'STAGING',
  PRODUCTION: 'PRODUCTION'
} as const;
